<template lang="html">
  <svg xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" height="48" width="48" version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" viewBox="0 0 47.999998 48.000002">
    <g transform="translate(0 -1004.4)">
      <g transform="translate(-101.22 887.7)">
        <circle :style="{'fill': circleFill}" cx="125.22" cy="140.66" r="24"/>
        <g transform="matrix(.061808 0 0 .061808 109.72 125.16)">
          <path style="fill:#40596b" d="m501.55 32.392c0-9.404-7.314-16.718-16.718-16.718h-463.94c-11.486-.001-20.89 9.404-20.89 20.897v321.83h501.55v-326.01z"/>
          <path style="fill:#f2f2f2" d="m0 358.4v39.706c0 11.494 9.404 20.898 20.898 20.898h459.76c11.494 0 20.898-9.404 20.898-20.898v-39.706h-501.56z"/>
          <circle style="fill:#cdd6e0" cx="250.78" r="11.494" cy="388.7"/>
          <rect style="fill:#cdd6e0" height="39.706" width="192.26" y="419" x="154.64"/>
          <rect style="fill:#f2f2f2" height="27.167" width="272.72" y="458.71" x="113.89"/>
          <rect style="fill:#acb3ba" height="15.673" width="192.26" y="419" x="154.64"/>
          <rect style="fill:#fff" height="282.12" width="434.68" y="45.976" x="33.437"/>
          <rect style="fill:#cdd6e0" height="24.033" width="63.739" y="225.7" x="329.14"/>
          <rect style="fill:#cdd6e0" height="24.033" width="104.49" y="181.81" x="329.14"/>
          <rect style="fill:#cdd6e0" height="24.033" width="63.739" y="225.7" x="198.53"/>
          <rect style="fill:#cdd6e0" height="24.033" width="104.49" y="181.81" x="198.53"/>
          <rect style="fill:#cdd6e0" height="24.033" width="63.739" y="225.7" x="66.873"/>
          <rect style="fill:#cdd6e0" height="24.033" width="104.49" y="181.81" x="66.873"/>
          <rect style="fill:#ffd15c" height="75.233" width="104.49" y="76.278" x="66.873"/>
          <rect style="fill:#ff7058" height="75.233" width="104.49" y="76.278" x="198.53"/>
          <rect style="fill:#acb3ba" height="75.233" width="104.49" y="76.278" x="329.14"/>
        </g>
      </g>
    </g>
  </svg>

</template>

<script>
export default {
  name: 'Dashboard',
  props: {
    circleFill: {
      default: '#bdcdda'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/menu/Dashboard.vue